import React, { useEffect } from "react";
import {
  Button,
  TextField,
  MenuItem,
  Autocomplete,
  Grid,
  Paper,
  createMuiTheme,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { OBTENER_PLAZAS } from "../../../../graphql/plazas";
import { OBTENER_PERSONAS } from "../../../../graphql/personas";
import { useMutation, useQuery } from "@apollo/client";
import { useFormik } from "formik";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { es } from "date-fns/locale";
import * as Yup from "yup";
import {
  CREAR_COBRO,
  LISTAR_TAZAS,
  OBTENER_COBROS,
} from "../../../../graphql/movimientos";
import { useState } from "react";
import Iconify from "../../../../components/Iconify";
import useAuth from "../../../../hooks/useAuth";

import FrmDetailCobro from "./FrmDetailCobro";
const FrmAgregarCobro = ({
  setOpenDialog,
  setOpenSnackBar,
  setErrorGraph,
  mes,
}) => {
  const { auth } = useAuth();
  let tipo = "";
  auth.role === "admin" ? (tipo = "%") : (tipo = auth.id);
  //Graphql
  const { data: plazadata, loading: plazaloading } = useQuery(OBTENER_PLAZAS);

  const [finalMonto, setFinalData] = useState([]);

  const { data: personadata, loading: personaloading } =
    useQuery(OBTENER_PERSONAS);

  const [agregarCobro] = useMutation(CREAR_COBRO, {
    update(cache, { data: { agregarCobro } }) {
      const { obtenerCobros } = cache.readQuery({
        variables: {
          UserId: tipo,
          fecha: mes,
        },
        query: OBTENER_COBROS,
      });
      cache.writeQuery({
        query: OBTENER_COBROS,
        variables: {
          UserId: tipo,
          fecha: mes,
        },
        data: {
          obtenerCobros: [...obtenerCobros, agregarCobro],
        },
      });
    },
  });
  const formik = useFormik({
    initialValues: {
      PlazaId: "",
      turno: "",
      fechaTrabajo: "",
      fechaReporte: "",
      PersonaId: "",
      detalleIngreso: [],
    },
    validationSchema: Yup.object({
      PlazaId: Yup.string().required("La Plaza es requerida"),
      turno: Yup.string().required("El turno de trabajo es requerido"),
      PersonaId: Yup.string().required("El delegado es requerido"),
    }),
    onSubmit: async (inputData) => {
      console.log(tipo);
      try {
        if (finalMonto.length > 0) {
          const result = await agregarCobro({
            variables: {
              input: {
                PlazaId: parseInt(inputData.PlazaId),
                turno: parseInt(inputData.turno),
                fechaTrabajo: inputData.fechaTrabajo,
                fechaReporte: inputData.fechaReporte,
                PersonaId: parseInt(inputData.PersonaId),
                tipo: parseInt(inputData.tipo),
              },
              cobro: finalMonto,
            },
          });

          formik.resetForm();
          resetFechas();

          setOpenSnackBar(true);

          setErrorGraph({
            mensaje: result.data.agregarCobro,
            severity: "success",
          });
        } else {
          setOpenSnackBar(true);
          setErrorGraph({
            mensaje: "Se debe agregar primero el registro del ingreso",
            severity: "error",
          });
        }
      } catch (error) {
        setOpenSnackBar(true);
        setErrorGraph({ mensaje: error.message, severity: "error" });
        console.log(error);
      }
    },
  });
  const [inputValue, setInputValue] = useState("");
  const [inputPlaza, setInputPlaza] = useState("");

  const handleOpenDialog = () => {
    setOpenDialog(false);
  };

  const resetFechas = () => {
    formik.setFieldValue("fechaTrabajo", null);
    formik.setFieldValue("fechaReporte", null);
    formik.setFieldValue("PersonaId", "");
    formik.setFieldValue("PlazaId", "");
    setFinalData([]);
    setInputValue("");
    setInputPlaza("");
  };

  if (plazaloading || personaloading )
    return <h1>Generando elementos</h1>;

  const addRows = (data) => {
    const totalMontos = finalMonto.length;
    data.id = totalMontos + 1;
    const updateData = [...finalMonto];
    updateData.push(data);
    setFinalData(updateData);
    // console.log(data);
    // const totalStudents = studentData.length;
    // data.id = totalStudents + 1;
    // const updatedStudentData = [...studentData];
    // updatedStudentData.push(data);
    // setStudentData(updatedStudentData);
  };

  const { obtenerPlazas } = plazadata;
  const { obtenerPersonas } = personadata;
  
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Paper style={{ padding: 10 }}>
          <Grid container alignItems="flex-start" spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Autocomplete
                freeSolo
                fullWidth
                id="PersonaId"
                name="PersonaId"
                options={obtenerPersonas}
                key={(x) => x.id}
                getOptionLabel={(option) =>
                  option.nombre + " " + option.apellidos
                }
                onChange={(e, value) => {
                  formik.setFieldValue("PersonaId", value.id);
                }}
                inputValue={inputValue}
                onInputChange={(_, v) => setInputValue(v)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Delegado"
                    fullWidth
                    variant="standard"
                  />
                )}
              />
              {formik.errors.PersonaId}
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <Autocomplete
                fullWidth
                freeSolo
                id="PlazaId"
                name="PlazaId"
                options={obtenerPlazas}
                getOptionLabel={(option) => option.nombre}
                onChange={(e, value) => {
                  formik.setFieldValue("PlazaId", value.id);
                }}
                inputValue={inputPlaza}
                onInputChange={(_, v) => setInputPlaza(v)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Plazas"
                    variant="standard"
                    name="PlazaId"
                    fullWidth
                  />
                )}
              />
              {formik.errors.PlazaId}
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <TextField
                select
                fullWidth
                name="turno"
                id="turno"
                label="Turno"
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.turno}
              >
                <MenuItem value="1">Matutino</MenuItem>
                <MenuItem value="2">Vespertino</MenuItem>
              </TextField>
              {formik.errors.turno}
            </Grid>

            <Grid item xs={12} md={12} lg={6}>
              <LocalizationProvider
                adapterLocale={es}
                dateAdapter={AdapterDateFns}
              >
                <DatePicker
                  onChange={(date) =>
                    formik.setFieldValue("fechaTrabajo", date)
                  }
                  value={formik.values.fechaTrabajo}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="fechaTrabajo"
                      fullWidth
                      variant="standard"
                      label="Fecha de Trabajo"
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <LocalizationProvider
                adapterLocale={es}
                dateAdapter={AdapterDateFns}
              >
                <DatePicker
                  onChange={(date) =>
                    formik.setFieldValue("fechaReporte", date)
                  }
                  value={formik.values.fechaReporte}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="fechaReporte"
                      fullWidth
                      variant="standard"
                      label="Fecha de Reporte"
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <FrmDetailCobro func={addRows} />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <Paper sx={{ width: "100%", overflow: "hidden" }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                  <Table
                    sx={{ minWidth: 650 }}
                    size="small"
                    aria-label="ingresos"
                    stickyHeader
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Ingreso</TableCell>
                        <TableCell>Folios</TableCell>
                        <TableCell>T.Folios</TableCell>
                        <TableCell>T.Permisos</TableCell>
                        <TableCell>Monto</TableCell>
                        <TableCell>Comisiones</TableCell>
                        <TableCell>Neto</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {finalMonto.map((info) => {
                        return (
                          <TableRow hover key={info.id} tabIndex={-1}>
                            <TableCell>
                              {
                                {
                                  1: "Basura",
                                  2: "Permisos",
                                }[info.tipoIngreso]
                              }
                            </TableCell>
                            <TableCell>{info.folioIngreso}</TableCell>
                            <TableCell>{info.totalFolios}</TableCell>
                            <TableCell>{info.totalPermisos}</TableCell>
                            <TableCell>{info.monto}</TableCell>
                            <TableCell>{info.comision}</TableCell>
                            <TableCell>{info.neto}</TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>

            <Grid item xs={12} md={12} lg={6}>
              <Button
                type="submit"
                startIcon={<Iconify icon="eva:save-outline" />}
                onClick={formik.handleSubmit}
              >
                Guardar
              </Button>
              <Button
                onClick={() => handleOpenDialog()}
                color="error"
                startIcon={<Iconify icon="eva:close-outline" />}
              >
                Cerrar
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </form>
    </>
  );
};

export default FrmAgregarCobro;
